import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Renderer2,
  } from "@angular/core";
  import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
  import { Router, ActivatedRoute } from "@angular/router";
  import { FormBuilder, FormGroup } from "@angular/forms";
  import { from } from "rxjs";
  import { DatePipe } from "@angular/common";
  import {
    HttpClient,
    HttpParams,
    HttpRequest,
    HttpHeaders,
  } from "@angular/common/http";
  import { SignaturePad } from "angular2-signaturepad";
  import { ApiHelper } from "src/app/_helpers/api.helper";
  import { CommonHelper } from "src/app/_helpers/common.helper";
  import { AppConfig } from "src/app/app.config";
  import { UserService } from "src/app/_services/user.service";
  import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
  import { Message } from "src/app/_locale/message";
import { faL } from "@fortawesome/free-solid-svg-icons";
  
  @Component({
    selector: "app-greenberg-cosmetic-surgery-demographics",
    templateUrl: "./greenberg-cosmetic-surgery-demographics.component.html",
    styleUrls: ["./greenberg-cosmetic-surgery-demographics.component.scss"],
    providers: [AppConfig, CommonHelper],
  })
  export class GreenbergCosmeticSurgeryDemographics implements OnInit {
    httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    httpOptions = {
      headers: this.httpHeaders,
    };
    hippaJson: any = {};
    loggedInUserId: string;
    userSignatures: any = [];
    userSignatureSelected = false;
    userFullSignature = "";
    userInitialSignature = "";
    userChoosedSignature = "";
    userSignatureSelected1 = false;
    userChoosedSignature1 = "";
    userFullSignatureExit = false;
    userInitialSignatureExis = false;
    showPdfModal = false;
    signatureType: any;
    dob: any;
    showLoader: boolean;
    ssnPattern = "^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$";
  
    resultJsonObj: any = {};
    clean = "0";
    @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
    @ViewChild("canvasArea", { static: true }) canvasArea: ElementRef;
    canvasElm: any;
    public signaturePadOptions: Object = {
      minWidth: 1,
      canvasWidth:
        window.innerWidth < 1024 ? window.innerWidth : window.innerWidth / 2,
      canvasHeight: 450,
    };
  
    currentDate = new Date();
    dateFormat = "MM-dd-yyyy";
  
    userWitnessSignatureSelected = false;
    userWitnessChoosedSignature = "";
  
    signatureFroWhom: any;
    isEmail: any;
    isPracticePhy: any;
    physicianId: any;
    requestId: any;
    tempId: any;
    userOptionId: any;
    emailLogId: any;
    message = Message;
    sendDocRoute = sessionStorage.getItem("sendDocRoute");
    loggedInrName: string;
    loggedInName: string;
    currentDay: string;
    operativeProcedure: string;
    demographicId: string;
    phyicianId: string;
    invitationId: string;
    parentId: string | number;
    childRoute: string;
    age : any;
    gender : any;
    state: any;
    city: any;
    Zip: any;
    street : any;
    fullAddress: any;
    documentId: any;

    constructor(
      public commonHelper: CommonHelper,
      private appConfig: AppConfig,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private sanitizer: DomSanitizer,
      public sweetAlertHelper: SweetAlertHelper,
      public userService: UserService
    ) {
      localStorage.setItem('childRoute', activatedRoute.snapshot.url[0].path);
      this.childRoute = activatedRoute.snapshot.url[0].path;
      this.loggedInUserId =
        this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
      this.demographicId =
        this.activatedRoute.snapshot.paramMap.get("demographicId");
      this.phyicianId = this.activatedRoute.snapshot.paramMap.get("phyicianId");
      this.invitationId =
        this.activatedRoute.snapshot.paramMap.get("invitationId");
      this.parentId = this.activatedRoute.snapshot.paramMap.get("parentId")
        ? this.activatedRoute.snapshot.paramMap.get("parentId")
        : 0;
  
      // this.loggedInUserId = localStorage.getItem("delegateId")
      //   ? localStorage.getItem("delegateId")
      //   : this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
      // this.isEmail = this.activatedRoute.snapshot.paramMap.get("isEmail")
      //   ? this.activatedRoute.snapshot.paramMap.get("isEmail")
      //   : 0;
      this.isPracticePhy =
        this.activatedRoute.snapshot.paramMap.get("isPracticePhy");
      this.physicianId = this.activatedRoute.snapshot.paramMap.get("physicianId")
        ? this.activatedRoute.snapshot.paramMap.get("physicianId")
        : 0;
      this.requestId = this.activatedRoute.snapshot.paramMap.get("requestId")
        ? this.activatedRoute.snapshot.paramMap.get("requestId")
        : 0;
  
      this.tempId = this.activatedRoute.snapshot.paramMap.get("tempId")
        ? this.activatedRoute.snapshot.paramMap.get("tempId")
        : 0;
      this.userOptionId = this.activatedRoute.snapshot.paramMap.get(
        "userOptionId"
      )
        ? this.activatedRoute.snapshot.paramMap.get("userOptionId")
        : 0;
      this.emailLogId = this.activatedRoute.snapshot.paramMap.get("emailLogId")
        ? this.activatedRoute.snapshot.paramMap.get("emailLogId")
        : 0;
  
      this.hippaJson.healthcare_provider = this.userService.getUS_FromatName(
        localStorage.getItem("providerName")
      );
      this.hippaJson.healthcare_provider_email =
        localStorage.getItem("providerEmail");
      this.hippaJson.healthcare_provider_npi = localStorage.getItem(
        "providerPhysicianNipNo"
      );
      this.hippaJson.street_address = localStorage.getItem(
        "providerOfficeAddress"
      );
      this.hippaJson.city_zip = localStorage.getItem("providerCity")
        ? localStorage.getItem("providerCity")
        : "" + ", " + localStorage.getItem("PhysicianStateName")
        ? localStorage.getItem("PhysicianStateName")
        : "" + ", " + localStorage.getItem("providerZipCode")
        ? localStorage.getItem("providerZipCode")
        : "";
  
      this.hippaJson.providerCity = localStorage.getItem("providerCity");
      this.hippaJson.providerPhone = localStorage.getItem("providerPhone");
      this.hippaJson.providerPhysicianNipNo = localStorage.getItem(
        "providerPhysicianNipNo"
      );
  
      
      this.loggedInUserId =
        this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
      this.demographicId =
        this.activatedRoute.snapshot.paramMap.get("demographicId");
      this.phyicianId = this.activatedRoute.snapshot.paramMap.get("phyicianId");
      this.invitationId =
        this.activatedRoute.snapshot.paramMap.get("invitationId");
      this.parentId = this.activatedRoute.snapshot.paramMap.get("parentId")
        ? this.activatedRoute.snapshot.paramMap.get("parentId")
        : 0;
      this.documentId = this.activatedRoute.snapshot.paramMap.get("documentId");
      this.fnFindSignature(this.loggedInUserId);
      this.fnFindDemographic(this.loggedInUserId);
      this.findUserDetails(this.loggedInUserId);
      this.hippaJson.patient_signature_date = this.currentDate;
      this.hippaJson.patient_signature1_date = this.currentDate;
      this.hippaJson.first_witness_signature_date = this.currentDate;
      this.hippaJson.pre_to = this.currentDate;
      this.hippaJson.post_to = this.currentDate;
      const today = new Date();
      this.currentDay = today.toISOString().split('T')[0];
    }
    ngOnInit() {
      // console.log(localStorage);
      this.hippaJson.ft = false;
      this.hippaJson.pt = false;
      this.hippaJson.checkbox_pat = false;
      this.hippaJson.checkbox_phy = false;
      this.hippaJson.checkbox_frd = false;
      this.hippaJson.checkbox_mouth = false;
      this.hippaJson.checkbox_web = false;
      this.hippaJson.checkbox_social = false;
      this.hippaJson.patient_signature = "";
      this.hippaJson.patient_signature1 = "";
      this.hippaJson.first_witness_signature = "";
      this.loggedInName = localStorage.getItem('loggedInUserName');
      this.hippaJson.checkbox_internet = false;
      this.hippaJson.checkbox_social = false;
      this.hippaJson.checkbox_radio = false;
      this.hippaJson.checkbox_tele = false;
      this.hippaJson.checkbox_facelift = false;
      this.hippaJson.checkbox_breastaugmentation = false;
      this.hippaJson.checkbox_liposuction = false;
      this.hippaJson.checkbox_botox = false;
      this.hippaJson.checkbox_browlift = false;
      this.hippaJson.checkbox_breastlift = false;
      this.hippaJson.checkbox_tummytuck = false;
      this.hippaJson.checkbox_fillers = false;
      this.hippaJson.checkbox_necklift = false;
      this.hippaJson.checkbox_breastrepair = false;
      this.hippaJson.checkbox_mommymakeover = false;
      this.hippaJson.checkbox_fatinjuction = false;
      this.hippaJson.checkbox_liquidfacelift = false;
      this.hippaJson.checkbox_breastimplant = false;
      this.hippaJson.checkbox_bodylift = false;
      this.hippaJson.checkbox_skinresu = false;
      this.hippaJson.checkbox_facefat = false;
      this.hippaJson.checkbox_breastcapsul = false;
      this.hippaJson.checkbox_buttock = false;
      this.hippaJson.checkbox_skintight = false;
      this.hippaJson.checkbox_rainoplasty = false;
      this.hippaJson.checkbox_breastreduction = false;
      this.hippaJson.checkbox_armlift = false;
      this.hippaJson.checkbox_hand = false;
      this.hippaJson.checkbox_lipaug = false;
      this.hippaJson.checkbox_thighlift = false;
      this.hippaJson.checkbox_hyper = false;
      this.hippaJson.checkbox_chinaug = false;
      this.hippaJson.checkbox_breastreconstruction = false;
      this.hippaJson.checkbox_fattransfer = false;
      this.hippaJson.checkbox_skincare = false;
      this.hippaJson.checkbox_uppereyelid = false;
      this.hippaJson.checkbox_malebreast = false;
      this.hippaJson.checkbox_otoplasty = false;
      this.hippaJson.checkbox_dermatologist = false;
      this.hippaJson.checkbox_lowereyelid = false;
      this.hippaJson.checkbox_breastothercheck = false;
      this.hippaJson.checkbox_vigina = false;
      this.hippaJson.checkbox_skinothercheck = false;
      this.hippaJson.checkbox_faceothercheck = false;
      this.hippaJson.checkbox_bodyothercheck = false;
    }
    formatDate(arg0: Date, dateFormat: string) {
      throw new Error("Method not implemented.");
    }

    fnFindSignature(user_id) {
      const reqData = {
        user_id,
      };
      return this.http
        .post(
          this.appConfig.getPhpUrl() + ApiHelper.php_findUserSignatureApi,
          reqData,
          this.httpOptions
        )
        .subscribe(
          (response: any) => {
            if (response.commandResult.success == 1) {
              this.userSignatures = response.commandResult.data.userSignatures;
              this.userFullSignature =
                response.commandResult.data.userSignatures.full_signature_url;
              this.userInitialSignature =
                response.commandResult.data.userSignatures.initial_signature_url;
  
              if (response.commandResult.data.userSignatures.full_signature_url) {
                this.userFullSignatureExit = true;
              }
  
              if (
                response.commandResult.data.userSignatures.initial_signature_url
              ) {
                this.userInitialSignatureExis = true;
              }
            } else {
            }
  
            // console.log(this.userSignatures);
          },
          (err) => {}
        );
    }
  
    async onSubmit() {
      const alertStatus = await this.sweetAlertHelper.confirmPopUp(
        this.message.confirmTitle,
        this.message.confirmMessages.njComp.preop 
      );
      if (alertStatus) {
        const reqData = {
          loggedInUserId: this.loggedInUserId,
          patientName: this.loggedInName,
          date:this.currentDay,
          operativeDate:this.resultJsonObj.operativeDate,
          operativeProcedure:this.resultJsonObj.operativeProcedure,
          parent : this.resultJsonObj.parent,
          signature_url:this.userFullSignature,
          dob:this.dob,
          ssn : this.resultJsonObj.ssn,
          age:this.age,
          gender:this.gender,
          state: this.state,
          city: this.city,
          Zip: this.Zip,
          street : this.street,
          fullAddress : this.fullAddress,
          home_phone : this.resultJsonObj.home_phone,
          primary_phy : this.resultJsonObj.primary_phy,
          work_phone : this.resultJsonObj.work_phone,
          dr_address : this.resultJsonObj.dr_address,
          cell_phone : this.resultJsonObj.cell_phone,
          dr_phone : this.resultJsonObj.dr_phone,
          email : this.resultJsonObj.email,
          occupation : this.resultJsonObj.occupation,
          ft : this.resultJsonObj.ft,
          pt : this.resultJsonObj.pt,
          employer : this.resultJsonObj.employer,
          checkbox_pat : this.resultJsonObj.checkbox_pat,
          checkbox_phy : this.resultJsonObj.checkbox_phy,
          checkbox_frd : this.resultJsonObj.checkbox_frd,
          checkbox_mouth : this.resultJsonObj.checkbox_mouth,
          checkbox_web : this.resultJsonObj.checkbox_web,
          checkbox_social : this.resultJsonObj.checkbox_social,
          checkbox_internet :this.resultJsonObj.checkbox_internet,
          checkbox_magazine : this.resultJsonObj.checkbox_magazine,
          checkbox_radio : this.resultJsonObj.checkbox_radio,
          checkbox_tele : this.resultJsonObj.checkbox_tele,
          source : this.resultJsonObj.source,
          Emergency : this.resultJsonObj.Emergency,
          Home_ph : this.resultJsonObj.Home_ph,
          relation : this.resultJsonObj.relation,
          other_ph : this.resultJsonObj.other_ph,
          pry_insu : this.resultJsonObj.pry_insu,
          insu_id : this.resultJsonObj.insu_id,
          Insu1_relation : this.resultJsonObj.Insu1_relation,
          Insu1_DOB : this.resultJsonObj.Insu1_DOB,
          Insu2 : this.resultJsonObj.Insu2,
          Insu2_ss : this.resultJsonObj.Insu2_ss,
          Insu2_relation : this.resultJsonObj.Insu2_relation,
          Insu2_dob : this.resultJsonObj.Insu2_dob,
          checkbox_facelift :this.resultJsonObj.checkbox_facelift,
          checkbox_breastaugmentation : this.resultJsonObj.checkbox_breastaugmentation,
          checkbox_liposuction :  this.resultJsonObj.checkbox_liposuction,
          checkbox_botox : this.resultJsonObj.checkbox_botox,
          checkbox_browlift : this.resultJsonObj.checkbox_browlift,
          checkbox_breastlift : this.resultJsonObj.checkbox_breastlift,
          checkbox_tummytuck : this.resultJsonObj.checkbox_tummytuck,
          checkbox_fillers : this.resultJsonObj.checkbox_fillers,
          checkbox_necklift : this.resultJsonObj.checkbox_necklift,
          checkbox_breastrepair : this.resultJsonObj.checkbox_breastrepair,
          checkbox_mommymakeover : this.resultJsonObj.checkbox_mommymakeover,
          checkbox_fatinjuction : this.resultJsonObj.checkbox_fatinjuction,
          checkbox_liquidfacelift : this.resultJsonObj.checkbox_liquidfacelift,
          checkbox_breastimplant : this.resultJsonObj.checkbox_breastimplant,
          checkbox_bodylift : this.resultJsonObj.checkbox_bodylift,
          checkbox_skinresu : this.resultJsonObj.checkbox_skinresu,
          checkbox_facefat : this.resultJsonObj.checkbox_facefat,
          checkbox_breastcapsul : this.resultJsonObj.checkbox_breastcapsul,
          checkbox_buttock : this.resultJsonObj.checkbox_buttock,
          checkbox_skintight : this.resultJsonObj.checkbox_skintight,
          checkbox_rainoplasty : this.resultJsonObj.checkbox_rainoplasty,
          checkbox_breastreduction : this.resultJsonObj.checkbox_breastreduction,
          checkbox_armlift : this.resultJsonObj.checkbox_armlift,
          checkbox_hand : this.resultJsonObj.checkbox_hand,
          checkbox_lipaug : this.resultJsonObj.checkbox_lipaug,
          checkbox_thighlift : this.resultJsonObj.checkbox_thighlift,
          checkbox_hyper : this.resultJsonObj.checkbox_hyper,
          checkbox_chinaug : this.resultJsonObj.checkbox_chinaug,
          checkbox_breastreconstruction : this.resultJsonObj.checkbox_breastreconstruction,
          checkbox_fattransfer : this.resultJsonObj.checkbox_fattransfer,
          checkbox_skincare : this.resultJsonObj.checkbox_skincare,
          checkbox_uppereyelid : this.resultJsonObj.checkbox_uppereyelid,
          checkbox_malebreast : this.resultJsonObj.checkbox_malebreast,
          checkbox_otoplasty : this.resultJsonObj.checkbox_otoplasty,
          checkbox_dermatologist : this.resultJsonObj.checkbox_dermatologist,
          breast_other : this.resultJsonObj.breast_other,
          skin_other : this.resultJsonObj.skin_other,
          checkbox_lowereyelid : this.resultJsonObj.checkbox_lowereyelid,
          checkbox_breastothercheck : this.resultJsonObj.checkbox_breastothercheck,
          checkbox_vigina : this.resultJsonObj.checkbox_vigina,
          checkbox_skinothercheck : this.resultJsonObj.checkbox_skinothercheck,
          checkbox_faceothercheck : this.resultJsonObj.checkbox_faceothercheck,
          checkbox_bodyothercheck : this.resultJsonObj.checkbox_bodyothercheck,
          face_other : this.resultJsonObj.face_other,
          body_other : this.resultJsonObj.body_other,
          phyicianId: this.phyicianId,
          documentId: this.documentId,
          docType: "12",
        };
        this.showLoader = true;
        return this.http
          .post(
            this.appConfig.getLambdaUrl06()+ApiHelper.greenbergCosmeticSurgeryDemographics,
            reqData,
            this.httpOptions
          )
          .subscribe(
            (response: any) => {
              if (response.success == 1) {
                const docId = response.docId;
                const docName= response.docName;
                const docUrl= response.docUrl;
                console.log("docName: ",docName,"docUrl: ",docUrl);
                // Retrieve existing document IDs from sessionStorage
                let docIds = JSON.parse(sessionStorage.getItem("documentIds")) || [];                
                if (!docIds.includes(docId)) {
                  docIds.push(docId);
                }
                // Store updated list in sessionStorage
                sessionStorage.setItem("documentIds", JSON.stringify(docIds));
                let docGroupArrayId = JSON.parse(sessionStorage.getItem("groupDocIds")) || [];                
                if (!docGroupArrayId.includes(Number(this.documentId))) {                  
                  docGroupArrayId.push(Number(this.documentId));                 
                  sessionStorage.setItem("groupDocIds", JSON.stringify(docGroupArrayId));
                }
                // Set checkbox status as true in sessionStorage
                sessionStorage.setItem(`${this.documentId}`, "true");               
                let docsArray = JSON.parse(sessionStorage.getItem("practiceDocs")) || [];              
                const newDoc = {
                    docName: docName,
                    docUrl: docUrl
                };               
                // Add the new document object to the docs array
                docsArray.push(newDoc);                
                sessionStorage.setItem("practiceDocs", JSON.stringify(docsArray));
                // window.open(response.message, "_blank");
  
                this.showLoader = false;
                this.router.navigate([
                  "/hippa-acceptance/" +
                    this.activatedRoute.snapshot.paramMap.get("loggedInUserId") +"/" +
                      this.demographicId +
                      "/" +
                      this.phyicianId +
                      "/" + 
                      this.invitationId +
                      "/" +
                      this.parentId
                ]);
              } else {
                if (window.open(response.commandResult.data, "_blank")) {
                  this.router.navigate([
                    "/dashboard/" +
                      this.activatedRoute.snapshot.paramMap.get("loggedInUserId"),
                  ]);
                }
              }
            },
            (err) => {}
          );
      }
    }
  
    
  
    closePdfModal() {
      this.showPdfModal = false;
      this.hippaJson.patient_signature = "";
    }
  
    openSignatureCanvas(selectedValue, signatureFroWhom) {
      this.signatureFroWhom = signatureFroWhom;
      // console.log(selectedValue);
      this.signatureType = selectedValue;
      if (
        selectedValue == "AFS" ||
        selectedValue == "AFS1" ||
        selectedValue == "AIS" ||
        selectedValue == "AWTSG"
      ) {
        this.showPdfModal = true;
      }
      if (selectedValue == "FS" || selectedValue == "IS") {
        this.userSignatureSelected = true;
        if (selectedValue == "FS") {
          this.userChoosedSignature = this.userFullSignature;
        }
        if (selectedValue == "IS") {
          this.userChoosedSignature = this.userInitialSignature;
        }
      }
    }
    
  
    ngAfterViewInit() {
      // this.signaturePad is now available
      this.signaturePad.set("minWidth", 1); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  
    drawComplete() {
      // will be notified of szimek/signature_pad's onEnd event
      // console.log(this.signaturePad.toDataURL());
    }
  
    async saveCanvas() {
      const alertStatus = await this.sweetAlertHelper.confirmPopUp(
        this.message.confirmTitle,
        this.message.confirmMessages.njComp.saveCanvas
      );
      // if (
      //   confirm(
      //     "PLEASE CONFIRM: This will replace your existing signature. Do you wish to change?"
      //   )
      // )
      if (alertStatus) {
        const reqData = {
          loggedInUserId: this.loggedInUserId,
          signatureBase64: this.signaturePad.toDataURL(),
          signatureType: this.signatureType,
        };
        return this.http
          .post(
            this.appConfig.getLambdaUrl05() +
              ApiHelper.name_saveSignatureImageApi,
            reqData,
            this.httpOptions
          )
          .subscribe(
            (apiResponse: any) => {
              if (apiResponse.commandResult.status == 1) {
                this.userSignatureSelected = true;
                this.userChoosedSignature =
                  apiResponse.commandResult.data.fileInfo.signatureUrl;
                // console.log(this.userChoosedSignature);
                this.fnFindSignature(this.loggedInUserId);
                this.showPdfModal = false;
                // this.hippaJson.patient_signature = '';
              }
            },
            (err) => {
              // console.log(err);
            }
          );
      }
    }
  
    async clearCanvas() {
      const alertStatus = await this.sweetAlertHelper.confirmPopUp(
        this.message.confirmTitle,
        this.message.confirmMessages.njComp.clearCanvas
      );
      // if (
      //   confirm("PLEASE CONFIRM: Are you sure you want to clear you signature.")
      // )
      if (alertStatus) {
        this.signaturePad.clear();
      }
    }
  
    drawStart() {}
  
    findUserDetails(userId) {
      const finalData = {
        company_slug: null,
        id: userId,
      };
      return this.http
        .post(
          this.appConfig.getLambdaUrl03() + ApiHelper.name_getUserDetailApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse: any) => {
            if (apiResponse.commandResult.status == 1) {
              this.hippaJson.patient_name =
                apiResponse.commandResult.data.userInfo.LastName +
                ", " +
                apiResponse.commandResult.data.userInfo.FirstName;
  
              // this.editDdemographicsformDataObj.fName = this.userService.getFirstName(
              //   apiResponse.commandResult.data.userInfo.FullName
              // );
              // this.editDdemographicsformDataObj.lName = this.userService.getLastName(
              //   apiResponse.commandResult.data.userInfo.FullName
              // );
            }
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  
    fnFindDemographic(user_id) {
      const finalData = {
        id: user_id,
      };
      this.http
        .post(
          this.appConfig.getLambdaUrl04() +
            ApiHelper.name_findUserDemographicGeneralApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (response: any) => {
            this.hippaJson.dob = new Date(
                this.dob=response.commandResult.data.userInfo.form1DOB,
              );
              this.gender=response.commandResult.data.userInfo.form1Gender;
                this.age=response.commandResult.data.userInfo.form1Age;
                this.state=response.commandResult.data.userInfo.form1State;
                this.street=response.commandResult.data.userInfo.form1StreetName;
                this.city=response.commandResult.data.userInfo.form1City;
                this.Zip=response.commandResult.data.userInfo.form1ZIP;
                this.fullAddress = `${this.city}, ${this.state} ${this.Zip}`;

            // this.hippaJson.city_zip = response.commandResult.data.userInfo.form1PrimaryPhysicianCity + ', ' + response.commandResult.data.userInfo.form1State + ', ' + response.commandResult.data.userInfo.form1ZIP;
  
            // this.hippaJson.street_address = response.commandResult.data.userInfo.form1StreetName;
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  
    autoFormatSSN() {
      // alert('Amit');
      let val = this.hippaJson.social_security_no.replace(/\D/g, "");
      // val = val.replace(/^(\d{3})/, "$1-");
      // val = val.replace(/-(\d{2})/, "-$1-");
      // val = val.replace(/(\d)-(\d{4}).*/, "$1-$2");
      this.hippaJson.social_security_no = val;
    }
  
    saveParentCanvas(signFor) {
      const reqData = {
        loggedInUserId: this.loggedInUserId,
        signatureBase64: this.signaturePad.toDataURL(),
        signatureType: this.signatureType,
        signFor,
      };
      return this.http
        .post(
          this.appConfig.getLambdaUrl05() +
            ApiHelper.name_saveParentSignatureImageApi,
          reqData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse: any) => {
            if (apiResponse.commandResult.status == 1) {
              if (signFor == "WTSG") {
                this.userWitnessSignatureSelected = true;
                this.userWitnessChoosedSignature =
                  apiResponse.commandResult.data.fileInfo.signatureUrl;
              }
              if (signFor == "AFS1") {
                this.userSignatureSelected1 = true;
                this.userChoosedSignature1 =
                  apiResponse.commandResult.data.fileInfo.signatureUrl;
              }
              this.showPdfModal = false;
            }
          },
          (err) => {
            // console.log(err);
          }
        );
    } 
    goBack(){
      this.router.navigate([
        "/hippa-acceptance/" +
          this.activatedRoute.snapshot.paramMap.get("loggedInUserId") +"/" +
            this.demographicId +
            "/" +
            this.phyicianId +
            "/" + 
            this.invitationId +
            "/" +
            this.parentId
      ]);
    } 
    
  }
  